import { Header } from '@/components/Layout/Header/Header';
import { CompanyForm } from '@/components/Views/Company/CompanyForm';
import { CompanyList } from '@/components/Views/Company/CompanyList';

const Company = () => {
  return (
    <div className="flex flex-col max-h-screen">
      <Header title="Entreprises" userName="Mas Aly" role="Admin" />
      <CompanyForm />
      <CompanyList />
    </div>
  );
};

export default Company;
